import { Mark } from "@tiptap/core";
import type { Attrs } from "@tiptap/pm/model";

export const calcYChangeStyle = (ychange: Record<string, any>) => {
  switch (ychange.type) {
    case "removed":
      return ``;
    case "added":
      return `text-decoration: underline; text-decoration-style: dotted; text-decoration-color: #12c012d4; text-decoration-thickness: 2px; text-underline-offset: 3px; background-color:#00ff0033`;
    case null:
      return "";
  }
};

export const calcYchangeDomAttrs = (attrs: Attrs, domAttrs: Record<string, any> = {}) => {
  domAttrs = Object.assign({}, domAttrs);
  if (attrs.ychange !== null) {
    domAttrs.ychange_user = attrs.ychange.user;
    domAttrs.ychange_type = attrs.ychange.type;
    domAttrs.ychange_color = attrs.ychange.color.light;
    domAttrs.style = calcYChangeStyle(attrs.ychange);
  }
  return domAttrs;
};

export const hoverWrapper = (ychange: any, content: any[]) =>
  ychange === null
    ? content
    : [
        [
          "span",
          {
            class: "ychange-hover bg-black px-2 rounded text-white font-medium",
          },
          ychange.user || "Team member",
        ],
        ["span", ...content],
      ];

export const YChange = Mark.create({
  name: "ychange",
  // we don’t want the mark to be active when the cursor is at its end
  inclusive: false,

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      user: { default: null },
      type: { default: null },
      color: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: "ychange" }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "ychange",
      {
        ychange_user: HTMLAttributes.user,
        ychange_type: HTMLAttributes.type,
        style: calcYChangeStyle(HTMLAttributes),
        ychange_color: HTMLAttributes.color.light,
      },
      ...hoverWrapper(HTMLAttributes, [0]),
    ];
  },
});
